
<h1 mat-dialog-title style="margin: 0px !important">{{ this.data?.Oid ? 'Modifica' : 'Creazione' }}
  Rubrica</h1>

<div mat-dialog-content>

  <app-address-book-save
  #form
  [data]="data"></app-address-book-save>

</div>

<div mat-dialog-actions class="d-flex space-between">

  <button mat-raised-button color="warn" [mat-dialog-close]="false">
    Annulla
  </button>

  <button mat-raised-button color="primary" (click)="onSubmit()">
    Salva
  </button>

</div>
